const routes = {
  login: '/login',
  otpverification: '/otpverification',
  emailverification: '/emailverification',
  signup: '/signup',
  onboarding: '/onBoarding',
  forgotPassword: '/forgotPassword',
  changePassword: '/changePassword',
  home: '/home',

  mentorship: '/mentorship',
  groups: '/groups',
  discoverGroups: '/groups/discover-groups',
  createGroup: '/groups/create-group',
  network: '/network',
  survey: '/survey',
  createSurvey: '/survey/create-survey',
  test: '/test',
  
  RequestService: '/support/RequestService',
  Answers: '/support/Answers',
  TicketPreview: '/support/TicketPreview',
  connectSocials: '/connect-social',

  // profile
  profile: '/profile',
  profileDetails: '/profile/profile-details',

  // MyPortfolio
  myPortfolio: '/myPortfolio',
  fundPortfolioDetails: '/myPortfolio/fund-Portfolio-Details',
  recentReports: '/myPortfolio/recent-reports',
  engagementrSummaryDetails: "/myPortfolio/summary",
  // people
  ourTeam: '/ourTeam',
  ourInvestors: '/ourInvestors',

  // getInvolved
  getinvolved: '/getInvolved',

  // startups
  startups: '/TS-Global-Portfolio',

  // events
  events: '/events',
  eventDetail: '/events',
  hostEvent: '/events/hostevent',

  // COE
  coe: '/COE',

  //support 
  support: '/support',
  faqs:'/support/FAQs',

  // jury portal
  juryPortal: '/GIC-Portal',
  assignedStartups: '/GIC-Portal/assigned-startups',
};

export default routes;